// Zodiac data
export const zodiacSigns = [
  {
    name: "Aries",
    symbol: "♈",
    emoji: "🐏",
    dateRange: "Mar 21 - Apr 19",
    date: { start: [3, 21], end: [4, 19] }
  },
  {
    name: "Taurus",
    symbol: "♉",
    emoji: "🐂",
    dateRange: "Apr 20 - May 20",
    date: { start: [4, 20], end: [5, 20] }
  },
  {
    name: "Gemini",
    symbol: "♊",
    emoji: "👯",
    dateRange: "May 21 - Jun 20",
    date: { start: [5, 21], end: [6, 20] }
  },
  {
    name: "Cancer",
    symbol: "♋",
    emoji: "🦀",
    dateRange: "Jun 21 - Jul 22",
    date: { start: [6, 21], end: [7, 22] }
  },
  {
    name: "Leo",
    symbol: "♌",
    emoji: "🦁",
    dateRange: "Jul 23 - Aug 22",
    date: { start: [7, 23], end: [8, 22] }
  },
  {
    name: "Virgo",
    symbol: "♍",
    emoji: "👩‍🌾",
    dateRange: "Aug 23 - Sep 22",
    date: { start: [8, 23], end: [9, 22] }
  },
  {
    name: "Libra",
    symbol: "♎",
    emoji: "⚖️",
    dateRange: "Sep 23 - Oct 22",
    date: { start: [9, 23], end: [10, 22] }
  },
  {
    name: "Scorpio",
    symbol: "♏",
    emoji: "🦂",
    dateRange: "Oct 23 - Nov 21",
    date: { start: [10, 23], end: [11, 21] }
  },
  {
    name: "Sagittarius",
    symbol: "♐",
    emoji: "🏹",
    dateRange: "Nov 22 - Dec 21",
    date: { start: [11, 22], end: [12, 21] }
  },
  {
    name: "Capricorn",
    symbol: "♑",
    emoji: "🐐",
    dateRange: "Dec 22 - Jan 19",
    date: { start: [12, 22], end: [1, 19] }
  },
  {
    name: "Aquarius",
    symbol: "♒",
    emoji: "🏺",
    dateRange: "Jan 20 - Feb 18",
    date: { start: [1, 20], end: [2, 18] }
  },
  {
    name: "Pisces",
    symbol: "♓",
    emoji: "🐟",
    dateRange: "Feb 19 - Mar 20",
    date: { start: [2, 19], end: [3, 20] }
  }
];

/**
 * Get zodiac sign based on date of birth
 * @param {Date} dateOfBirth - The user's date of birth
 * @returns {Object} Zodiac sign object
 */
export const getZodiacSign = (dateOfBirth) => {
  const month = dateOfBirth.getMonth() + 1; // 1-12
  const date = dateOfBirth.getDate();

  for (let sign of zodiacSigns) {
    const [startMonth, startDate] = sign.date.start;
    const [endMonth, endDate] = sign.date.end;

    if (startMonth === endMonth) {
      // Sign within same month (unlikely but covering)
      if (month === startMonth && date >= startDate && date <= endDate) {
        return sign;
      }
    } else if (startMonth < endMonth) {
      // Normal case: sign doesn't cross year boundary
      if (
        (month === startMonth && date >= startDate) ||
        (month === endMonth && date <= endDate)
      ) {
        return sign;
      }
    } else {
      // Sign crosses year boundary (e.g., Capricorn)
      if (
        (month === startMonth && date >= startDate) ||
        (month === endMonth && date <= endDate)
      ) {
        return sign;
      }
    }
  }

  return zodiacSigns[0]; // Fallback to Aries
};

/**
 * Get lucky number for the day (deterministic based on date)
 * @returns {number} Lucky number 1-9
 */
export const getLuckyNumber = (date = new Date()) => {
  const dateStr = date.toISOString().split('T')[0];
  const hash = dateStr.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return (hash % 9) + 1;
};

/**
 * Get lucky color
 * @returns {string} Hex color code
 */
export const getLuckyColor = (date = new Date()) => {
  const colors = [
    "#FF1493", // Deep Pink
    "#7C3AED", // Purple
    "#EC4899", // Hot Pink
    "#06B6D4", // Cyan
    "#F59E0B", // Amber
    "#10B981", // Emerald
    "#F3590D", // Orange Red
    "#06D6FF", // Bright Cyan
  ];
  const dateStr = date.toISOString().split('T')[0];
  const hash = dateStr.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return colors[hash % colors.length];
};

/**
 * Get vibe check emoji for the day
 * @returns {string} Emoji + word
 */
export const getVibeCheck = (date = new Date()) => {
  const vibes = [
    "✨ Chaotic",
    "🔥 Fiery",
    "🌙 Mysterious",
    "💫 Cosmic",
    "⚡ Explosive",
    "🌌 Surreal",
    "💀 Dark",
    "🎭 Unhinged",
  ];
  const dateStr = date.toISOString().split('T')[0];
  const hash = dateStr.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return vibes[hash % vibes.length];
};
